import { useAuth } from "@/context/AuthContext";
import MessageThread from "@/components/MessageThread";

export default function ClientMessages() {
  const { user } = useAuth();
  return (
    <div className="p-6 md:p-10 max-w-3xl mx-auto">
      <div className="id-label mb-3">— Direct Line —</div>
      <h1 className="id-h1 mb-2">Coach Chat</h1>
      <p className="text-zinc-400 font-manrope mb-8">Questions, form check requests, anything — drop your coach a line.</p>
      {user?.id && <MessageThread clientId={user.id} />}
    </div>
  );
}
